import { apm } from '@elastic/apm-rum';

export const trackEvent = (key: string, labels: Record<string, string> = {}) => {
  window.gtag?.('event', key, labels);

  const transaction = apm.startTransaction(key, 'user-interaction');
  if (transaction) {
    if (Object.keys(labels).length > 0) {
      transaction.addLabels(labels);
    }
    // Use setTimeout to give the transaction a non-zero duration
    setTimeout(() => transaction.end(), 100);
  }
};
